module.exports = __webpack_public_path__ + "static/mint-logo-ee402dda89debf9c4293cf733d11d53e.png";